import {
  GET_REVIEW_REASONS,
  GET_REVIEW_REASONS_REQUEST,
  GET_REVIEW_REASONS_RESPONSE,
  GET_REVIEW_REASONS_ERROR,
} from 'actions/reviews';

const initialState = {
  isLoading: false,
  isError: false,
  reasons: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_REVIEW_REASONS_REQUEST:
    case GET_REVIEW_REASONS:
      return {
        ...state,
        isLoading: true,
      };
    case GET_REVIEW_REASONS_RESPONSE:
      return {
        ...state,
        isLoading: false,
        reasons: action.response.reviewReasons,
      };
    case GET_REVIEW_REASONS_ERROR:
      return { ...state, isLoading: false, isError: true, reasons: [] };
    default:
      return state;
  }
};
